import React from 'react';
import { createContext, useContext, useState } from 'react';
import type { FrameContext } from './types';

interface OwasFrameProviderProps {
	children: JSX.Element;
}

const OwasEvaluationContext = createContext<FrameContext>({} as FrameContext);

export function OwasEvaluationProvider({ children }: OwasFrameProviderProps) {
	const [filters, setFilters] = useState<{}>({
		name: undefined,
		type: 'all'
	});

	const stepFormName = 'evaluation';

	function handleChangeAnalyzedFilter(type: string): void {
		setFilters({ ...filters, type });
	}

	function handleChangeNameFilter(name: string): void {
		setFilters({ ...filters, name });
	}

	const states = {
		filters,
		stepFormName
	};

	const methods = {
		onFilterName: handleChangeNameFilter,
		onFilterAnalyzed: handleChangeAnalyzedFilter
	};

	const value = {
		...states,
		...methods
	};

	return <OwasEvaluationContext.Provider value={value}>{children}</OwasEvaluationContext.Provider>;
}

export function useOwasEvaluationContext() {
	const context = useContext(OwasEvaluationContext);
	return context;
}
